import { officeApiMailbox_AddHandlerAsync } from './async/office-api-mailbox-async'
import { officeApiItem_AddHandlerAsync, officeApiItem_RemoveHandlerAsync } from './async/office-api-mailbox-item-async'

export async function officeAddHandler(eventType: Office.EventType, handler: any): Promise<boolean> {
  let addHandlerFunction: any

  if (eventType === Office.EventType.ItemChanged) {
    addHandlerFunction = officeApiMailbox_AddHandlerAsync
  } else {
    addHandlerFunction = officeApiItem_AddHandlerAsync
  }

  try {
    return await addHandlerFunction(eventType, handler)
  } catch {
    return false
  }
}

export async function officeRemoveHandler(eventType: Office.EventType): Promise<boolean> {
  try {
    return await officeApiItem_RemoveHandlerAsync(eventType)
  } catch {
    return false
  }
}

const exportFunctions = {
  add: officeAddHandler,
  remove: officeRemoveHandler,
}

export default exportFunctions
